/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import {
    bool, func, node, object,
} from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import dialogCss from './Dialog.module.css';

const Dialog = ({
    isOpen, onClose, children, styles,
}) => {
    useEffect(() => {
        if (isOpen && typeof document !== 'undefined') {
            document.body.style.overflow = 'hidden';
        }
    }, [isOpen]);

    if (!isOpen) return <></>;
    useStyles(dialogCss);

    const dialogClose = () => {
        if (typeof document !== 'undefined') {
            document.body.style.overflow = '';
            onClose();
        }
    };

    return (
        <div className={`${dialogCss.dialogOverlay} dialog-container`}>
            <div className={`${dialogCss.dialogBackdropRoot}`} />
            <div className={`${dialogCss.dialogScrollPaper}`}>
                <div className={`${dialogCss.dialogContent} dialog-content`} style={{ '--comp-dialog-background-color': styles?.backgroundColor }}>
                    <div className={`${dialogCss.dialogHeader} dialog-header`}>
                        <button type="button" className={`${dialogCss.dialogCloseButton} dialog-close-button`} onClick={() => dialogClose()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <g clip-path="url(#clip0_555_350)">
                                    <path d="M15.8337 5.34163L14.6587 4.16663L10.0003 8.82496L5.34199 4.16663L4.16699 5.34163L8.82533 9.99996L4.16699 14.6583L5.34199 15.8333L10.0003 11.175L14.6587 15.8333L15.8337 14.6583L11.1753 9.99996L15.8337 5.34163Z" fill="white" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_555_350">
                                        <rect width="20" height="20" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                    <div className={`${dialogCss.dialogBody} dialog-body`}>
                        {children}
                    </div>
                </div>
            </div>

        </div>
    );
};

Dialog.propTypes = {
    children: node,
    isOpen: bool,
    onClose: func,
    styles: object,
};
Dialog.defaultProps = {
    children: (<></>),
    isOpen: false,
    onClose: () => {},
    styles: {},
};

export default Dialog;
